import {
  isFutureSet,
  isRevivalSet,
  STATS_FILTER_DEFAULT,
} from "@/game-tft/constants.mjs";
import getStatFilters from "@/game-tft/get-stats-filters.mjs";
import getValidatedSet from "@/game-tft/get-validated-set.mjs";

export default function getSetFiltersPatch(urlSearchParams, page) {
  // Filters for getStats
  const fSet = urlSearchParams?.get("set");
  // It feels at some point this was default to "avgplacement" and sorting was
  // delegated to the front-end since only 2/5 of the filters actually work now
  const fSort = STATS_FILTER_DEFAULT.sort;
  const fRank = urlSearchParams?.get("rank") || STATS_FILTER_DEFAULT.rank;
  const fRegion = urlSearchParams?.get("region") || STATS_FILTER_DEFAULT.region;
  const filters = `${fRank}_${fRegion}_${fSort}`.toLowerCase();

  // Get the latest patch the set is in (if present)
  const keySet = getValidatedSet(fSet);
  const isPBE = isFutureSet(keySet);
  const isRevival = isRevivalSet(keySet);
  const statFilters = getStatFilters(urlSearchParams, page, isPBE, isRevival);
  return {
    set: keySet,
    filters,
    statFilters,
    isFutureSet: isPBE,
    isRevivalSet: isRevival,
  };
}
